module.exports = __webpack_public_path__ + "img/logo fav.icon.6d09ff43.png";